import { useHistory } from "react-router-dom";
import InsightsIcon from "assets/dashboardIcons/InsightsIcon";
import { FunctionalButton } from "components/functionalButton";
import { ScreenRoot, StyledArea, StyledBox } from "pages/dashboard/styles";
import {
  IntroArea,
  ButtonContainer,
} from "pages/underwriterDashboard/functionSection/styles";
import { Content } from "pages/underwriterDashboard/styles";
import ObligeeIcon from "assets/dashboardIcons/ObligeeIcon";

export default function UnderwriterInsights() {
  const history = useHistory();

  const handleGoToPGA = () => {
    history.push("/underwriter-insights/peer-group-analysis");
  };

  const handleGoToPD = () => {
    history.push("/underwriter-insights/probability-of-default");
  };

  return (
    <>
      <ScreenRoot>
        <Content>
          <StyledArea
            style={{ 
              display: "flex", 
              flexDirection: "row", 
              gap: "16px",
              justifyContent: "center",
              alignItems: "center",
              width: "100%"
            }}
          >
            <StyledBox
              boxHeight="216px"
              boxWidth="220px"
              borderRadius="15px"
              isMobile={false}
              style={{ cursor: "pointer" }}
            >
              <IntroArea>
                <InsightsIcon width={100} height={100} isMobile={false} />
              </IntroArea>
              <ButtonContainer>
                <FunctionalButton
                  buttonTitle="Portfolio Insights"
                  width="80%"
                  marginRight="0px"
                  isReversedColor={true}
                  hasBoxShadow={true}
                  handleButton={handleGoToPGA}
                  disabled={false}
                  height={undefined}
                  marginLeft={undefined}
                  marginTop={undefined}
                  marginBottom={undefined}
                  fontSize={undefined}
                  icon={undefined}
                  frontIcon={undefined}
                  weight={undefined}
                  borderColor={undefined}
                  selected={undefined}
                />
              </ButtonContainer>
            </StyledBox>
            <StyledBox
              boxHeight="216px"
              boxWidth="220px"
              borderRadius="15px"
              isMobile={false}
              style={{ cursor: "pointer" }}
            >
              <IntroArea>
                <ObligeeIcon width={100} height={100} isMobile={false} />
              </IntroArea>
              <ButtonContainer>
                <FunctionalButton
                  buttonTitle="Account Insights"
                  width="80%"
                  marginRight="0px"
                  isReversedColor={true}
                  hasBoxShadow={true}
                  handleButton={handleGoToPD}
                  disabled={false}
                  height={undefined}
                  marginLeft={undefined}
                  marginTop={undefined}
                  marginBottom={undefined}
                  fontSize={undefined}
                  icon={undefined}
                  frontIcon={undefined}
                  weight={undefined}
                  borderColor={undefined}
                  selected={undefined}
                />
              </ButtonContainer>
            </StyledBox>
          </StyledArea>
        </Content>
      </ScreenRoot>
    </>
  );
}
